import { Component, OnInit } from '@angular/core';
import {addUser, editUserApi, getUserApi, getUsersApi} from '../api/users';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {getDriverApi} from '../api/drivers';
import {editUniversityApi, getUniversity} from '../api/university';
import {uplodeImage} from '../api/util';
import {MenuComponent} from '../menu/menu.component';
import swal from "sweetalert2";

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css'],
})
export class SettingsComponent implements OnInit {

  constructor(private _fb:FormBuilder) {}
  name=''
  typeText=''
  uni=''
  admins=[]
  data:FormGroup
  uniData:FormGroup
  editMode=false;
  changeImg=false
  uniDataView={}
  imageUplode=false
  profileImg="assets/images/profile-square.jpg"
  admin=[]
  isAdmin=false
  id=null
  ngOnInit() {
  this.name=localStorage.getItem('name')
    this.typeText=localStorage.getItem('type')=="1"?"مدير":localStorage.getItem('type')=='2'?'مدير الجركة':'ميديا'
      this.uni=localStorage.getItem('uni')
    this.getUsers()

    this.data=this._fb.group({
      name:['',Validators.required],
      email:['',Validators.required],
      password:['',Validators.required],
      phone:['',Validators.required],
      type:['',Validators.required],
      profile_photo:['']
    })
    this.uniData=this._fb.group({
      ar_name:['',Validators.required],
      address:[''],
      email:[''],
      phone:[''],
      website:[''],
      logo:[''],
    })
let uniID=localStorage.getItem('uni')
this.getUni(uniID)
  }

 async getUsers(){
   this.admin=[]
    let result=await getUsersApi()
   if(result){
     this.admins=result.data.data
     this.admins.map(row=>{
       if(row.type==1){
         this.admin.push(row._id.toString())
       }
     })
     this.profileImg="assets/images/profile-square.jpg"

   }
  }

  rowSelected={}
  selectedRow(row: any) {
    this.rowSelected = row;
  }

  async getUser(id: any) {
    const result = await getUserApi(id);
    this.editMode = true;
    this.id=id
    if (result) {

console.log('isadmin',id==this.admin)
console.log(this.admin)
console.log(id)
      const user = result.data.data;
      this.rowSelected = user;
      if(this.admin.includes(id.toString())){
        this.isAdmin=true
      }else {
        this.isAdmin=null
      }

      this.data = this._fb.group({
        name:[user.name,Validators.required],
        email:[user.email,Validators.required],
        password:[user.password,Validators.required],
        phone:[user.phone,Validators.required],
        type:[user.type,Validators.required],
        profile_photo:[user.profile_photo]

      });
      this.profileImg=user.profile_photo

    }



  }
  async getUni(id: any) {
    const result = await getUniversity(id);
    this.editMode = true;
    this.uniData = this._fb.group({
      ar_name:['',Validators.required],
      address: [''],
      email:[''],
      phone:[''],
      website:[''],
      logo:[''],
    });
    if (result) {

      const user = result.data.data;
      this.rowSelected = user;

      this.uniDataView=user
      this.uniData = this._fb.group({
        ar_name:[user.ar_name,Validators.required],
        address: [user.address],
        email:[user.email],
        phone:[user.phone],
        website:[user.website],
        logo:[user.logo],
      });

      this.profileImg=user.logo?user.logo:this.profileImg

    }



  }

  changeEditMode(){
    this.editMode=false
    this.data = this._fb.group({
      name:['',Validators.required],
      email:['',Validators.required],
      password:['',Validators.required],
      phone:['',Validators.required],
      type:['',Validators.required],
      profile_photo:[''],

    });
    this.profileImg="assets/images/profile-square.jpg"
    this.isAdmin=null
  }


  async edit() {
    let data=this.data.value
    if (this.imageUplode) {
      const img = data.profile_photo;
      const uplode = await uplodeImage(img);
      if (uplode) {

        data.profile_photo = uplode.data;
      }
    }
    let result=await editUserApi(data,this.id)

    if(result){
      this.getUsers()
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
      location.reload();
    }
  }


  async editUniversity(){
    let id=localStorage.getItem('uni')
    let data=this.uniData.value


    if (this.imageUplode) {
      const img = data.logo;
      const uplode = await uplodeImage(img);
      if (uplode) {

        data.logo = uplode.data;
      }
    }

    let result=editUniversityApi(id,data)
    if(result){
      this.getUni(id)
      localStorage.setItem('uniName',data.ar_name)
      localStorage.setItem('uniLogo',data.logo)
      location.reload();

      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
      // this.Menu.refreshStorge()
    }



  }



  async add() {
    let data=this.data.value
    if (this.imageUplode) {
      const img = data.profile_photo;
      const uplode = await uplodeImage(img);
      if (uplode) {

        data.profile_photo = uplode.data;
      }
    }
let result=await addUser(data)

    if(result){
      this.getUsers()
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }

  }
  changeUserImage(input) {
    let reader;
    if (input.target.files) {
      reader = new FileReader();

      reader.onload = (e) => {
        console.log(e.target.result);
        this.imageUplode=true

        this.data.get('profile_photo').setValue(e.target.result);
        this.profileImg=e.target.result
        // preview.setAttribute('src', e.target.result);
      }

      reader.readAsDataURL(input.target.files[0]);
    }
  }

  async removeAdmin(id){
    let result=await editUserApi({disabled:true},id)
    if(result){
      this.getUsers()
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }
  }

  changeImage(input) {
    console.log('sss', input);
    let reader;
    if (input.target.files) {
      reader = new FileReader();

      reader.onload = (e) => {
        console.log(e.target.result);
        this.imageUplode=true

        this.uniData.get('logo').setValue(e.target.result);
        this.profileImg=e.target.result
        // preview.setAttribute('src', e.target.result);
      }

      reader.readAsDataURL(input.target.files[0]);
    }
  }

  openFile() {
    document.getElementById('file').click();
  }
  openFile2() {
    document.getElementById('file2').click();
  }
}
